import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MediaObserver } from '@angular/flex-layout';
import { EligibleCitiesComponent } from '../eligible-cities/eligible-cities.component';

@Component({
  selector: 'app-alert-invalid-city',
  templateUrl: './alert-invalid-city.component.html',
  styleUrls: ['./alert-invalid-city.component.css']
})
export class AlertInvalidCityComponent implements OnInit {

  delivryAddress: any;
  innerHeight: number = window.innerHeight;

  constructor(
    @Inject(MAT_DIALOG_DATA) data:any,
    private dialogRef: MatDialogRef<AlertInvalidCityComponent>,
    private dialog: MatDialog,
    private media: MediaObserver
  ) {
    this.delivryAddress = data.delivryAddress;
  }

  ngOnInit() {
  }

  openEligibleCitiesDial() {
    let myConf = new MatDialogConfig();
    myConf.autoFocus = false;
    this.media.isActive("xs") ? myConf.width = "100%" : myConf.minWidth = "400px";
    this.dialog.open(EligibleCitiesComponent, myConf);
  }

  closeDial() {
    this.dialogRef.close();
  }

}
